export class LoadingSpinner extends HTMLElement {
  private shadow: ShadowRoot;

  constructor() {
    super();
    this.shadow = this.attachShadow({ mode: 'open' });
  }

  connectedCallback(): void {
    const text = this.getAttribute('text') || '';
    this.shadow.innerHTML = `
      <style>
        :host { display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 12px; padding: 32px; }
        .spinner {
          width: 36px; height: 36px;
          border: 3px solid var(--color-surface-container, #e7e5ea);
          border-top-color: var(--color-primary, #4355b9);
          border-radius: 50%;
          animation: spin .8s linear infinite;
        }
        @keyframes spin { to { transform: rotate(360deg); } }
        .text { font-size: .875rem; color: var(--color-on-surface-muted, #666); }
      </style>
      <div class="spinner"></div>
      ${text ? `<div class="text">${text}</div>` : ''}
    `;
  }
}

customElements.define('loading-spinner', LoadingSpinner);
